/* eslint-disable max-depth */
// don't try this at home
// you reckon changing prototypes is bad
// cop this:

import { v4 as uuid } from 'uuid';
import iframeOrExtPostMessage, {
  iframeOrExtExists
} from '../shared/utils/iframeOrExtPostMessage';

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export default class {
  token = uuid().toString();

  iframeElement = window.document.querySelector(
    '#bugherd_embed_communication_frame'
  );

  sendMessage = config => {
    if (!iframeOrExtExists()) {
      console.error(
        '[BUGHERD] Expected to message a BugHerd iframe, but it didnt exist'
      );
      return;
    }

    iframeOrExtPostMessage(config, '*');
  };

  constructor() {
    const listener = response => {
      try {
        if (response.data) {
          const { data } = response;
          const { payload } = data;

          if (
            data.EVENT_NAME === 'PROXY_XHR_RESPONSE' &&
            data.payload.token === this.token
          ) {
            if (
              payload.event === 'uploadAddEventListener' &&
              this[`uploadAddEventListener_${payload.name}`]
            ) {
              this[`uploadAddEventListener_${payload.name}`](...payload.args);
            } else if (
              payload.event === 'addEventListener' &&
              this[`addEventListener_${payload.name}`]
            ) {
              this[`addEventListener_${payload.name}`](...payload.args);
            } else if (payload.event === 'onload' && this.onload) {
              this.onload(...payload.args);

              Object.keys(payload).forEach(key => {
                if (!['args', 'token', 'event'].includes(key)) {
                  this[key] = payload[key];
                }
              });
            } else if (payload.event === 'onerror' && this.onerror) {
              this.onerror(...payload.args);
            } else if (
              payload.event === 'getAllResponseHeaders' &&
              this.onerror
            ) {
              this.getAllResponseHeaders = () => payload.args;
            } else {
              console.warn(
                `[BUGHERD] ${payload.event} is not supported`,
                payload
              );
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    window.addEventListener('message', listener);

    this.sendMessage(
      {
        EVENT_NAME: 'PROXY_XHR',
        payload: { event: 'create', token: this.token }
      },
      '*'
    );
  }

  open = (...args) => {
    this.sendMessage({
      EVENT_NAME: 'PROXY_XHR',
      payload: { event: 'open', args, token: this.token }
    });
  };

  upload = {
    addEventListener: (name, callback) => {
      this[`uploadAddEventListener_${name}`] = callback;

      this.sendMessage({
        EVENT_NAME: 'PROXY_XHR',
        payload: { event: 'uploadAddEventListener', name, token: this.token }
      });
    }
  };

  addEventListener = (name, callback) => {
    this[`addEventListener_${name}`] = callback;

    this.sendMessage({
      EVENT_NAME: 'PROXY_XHR',
      payload: { event: 'addEventListener', name, token: this.token }
    });
  };

  setRequestHeader = (header, value) => {
    this.sendMessage({
      EVENT_NAME: 'PROXY_XHR',
      payload: { event: 'setRequestHeader', header, value }
    });
  };

  getAllResponseHeaders = () => {
    return null;
  };

  send = async data => {
    let formattedData = data;

    // FormData isn't serializable
    // So deconstruct it here and reconstruct it on the other side
    if (data instanceof FormData) {
      formattedData = {};

      let formDataArray = null;

      /*
        Firefox extension content scripts don't support Iterators in most instances yet
        So we manually check if we can iterate through entries, if not, we create a new set
        and then iterate over it into an array.

      */
      let browserSupportsEntriesIteration = false;

      for (let pair of Object.entries(data)) {
        browserSupportsEntriesIteration = true;
      }

      if (!browserSupportsEntriesIteration) {
        const formDataSet = new Set(data);
        formDataArray = [];

        // We need to use a `forEach` here instead of `for...of` because Firefox wont support iteration like that
        formDataSet.forEach(pair => {
          formDataArray.push(pair);
        });
      }

      const entries = formDataArray || data.entries();

      for (let pair of entries) {
        // Browser wont serialize the file data cross domain
        // So we do it manually
        if (pair[0] === 'file') {
          formattedData.base64File = await toBase64(pair[1]);
          formattedData.base64FileName = pair[1].name;
        } else {
          formattedData[pair[0]] = pair[1];
        }
      }
    } else if (data === null) {
      formattedData = null;
    } else {
      console.error('[BUGHERD] The XHR proxy only supports FormData or null');
      return;
    }

    this.sendMessage({
      EVENT_NAME: 'PROXY_XHR',
      payload: { event: 'send', formData: formattedData, token: this.token }
    });
  };
}
